export interface CWIDProps {
  "cw-id"?: string;
}

export const stringToCWId = (string: string, prefix?: string): string =>
  `${prefix ? `${prefix}-` : ""}${string.split(" ").join("-")}`;
